import { Link } from "react-router-dom";
import { studentWorkspacePaths } from "@/utils/student-workspace";

export function ReportContextRequired({
  reportName,
  studentId,
}: {
  reportName: string;
  studentId: string;
}): JSX.Element {
  return (
    <section className="rounded-xl border border-dashed border-slate-300 bg-white p-10 text-center shadow-sm">
      <h2 className="text-lg font-semibold text-slate-800">请先选择评估记录</h2>
      <p className="mt-2 text-sm text-slate-500">
        {reportName}需要基于一份已完成且校验通过的评估生成。
      </p>
      <Link
        to={studentWorkspacePaths.assessments(studentId)}
        className="mt-5 inline-flex min-h-11 items-center justify-center rounded-md bg-brand px-5 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-brand-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand/40 focus-visible:ring-offset-2"
      >
        前往评估
      </Link>
    </section>
  );
}
